import type { WallTheme } from './types';

export const emptyWallTheme: WallTheme = {
  title: null,
  titleColor: '',
  titleBackgroundColor: '',
  yellowThemeColor: '',
  yellowThemeText: '',
  blueThemeColor: '',
  blueThemeText: '',
  redThemeColor: '',
  redThemeText: '',
  panelTitleColor: '',
  panelColor: '',
};

export function normalizeWallTheme(theme: Partial<WallTheme> | null | undefined): WallTheme {
  return {
    ...emptyWallTheme,
    ...theme,
    title: theme?.title ?? null,
  };
}
